import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

interface PanelCardProps {
  title: string;
  subtitle?: string;
  isDanger?: boolean;
  children: React.ReactNode;
}

function PanelCard({ title, subtitle, isDanger = false, children }: PanelCardProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        bgcolor: theme.palette.background.paper,
        border: `1px solid ${isDanger ? theme.palette.error.dark : theme.palette.divider}`,
        borderRadius: 2,
        p: { xs: 2.5, sm: 3.5 },
        mb: 2,
      }}
    >
      <Typography
        sx={{
          fontSize: 17,
          fontWeight: 800,
          mb: 0.5,
          color: isDanger ? theme.palette.error.main : theme.palette.text.primary,
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          sx={{
            fontSize: 13,
            color: theme.palette.text.disabled,
            mb: 3,
          }}
        >
          {subtitle}
        </Typography>
      )}
      {children}
    </Box>
  );
}

export default PanelCard;
